/**
 * Copyright (c) Microsoft. All rights reserved.
 */
/* eslint-disable no-console */
import { LogData, Logger } from 'src/core/services/telemetry/logger';

/**
 * Returns implementation of Logger that uses console logger
 * instance to log messages if current environment is dev.
 */
export const getConsoleLogger = (): Logger => {
    const info = (message: string, properties?: LogData) => console.info(message, printProperties(properties));

    const warn = (message: string, properties?: LogData) => console.warn(message, printProperties(properties));

    const error = (exception: Error, properties: LogData) => console.error(exception, printProperties(properties));

    const event = (name: string, properties?: LogData) => console.log(`Event: ${name}`, printProperties(properties));

    const startEvent = (name: string, properties?: LogData) => console.log(`Event start: ${name}`, printProperties(properties));

    const endEvent = (name: string, failed: boolean, properties?: LogData) => {
        if (failed) {
            properties = { ...properties, failed };
        }
        console.log(`Event end: ${name}`, printProperties(properties));
    };

    const logPageView = (name: string, properties?: LogData) => console.log(`Page viewed: ${name}`, printProperties(properties));

    return {
        info,
        warn,
        error,
        logEvent: event,
        startEvent,
        endEvent,
        logPageView
    };
};

const printProperties = (properties?: LogData) => (properties ? `\nProperties:\n ${JSON.stringify(properties ?? {}, null, 2)}` : null);
